<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Crypto Country</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="country"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12"> <custom-input name="name" label="Country Name" /> </v-col>
              <!-- <v-col cols="6">
                <custom-input
                  name="sending_min_amount"
                  type="number"
                  label="Sending Min Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="sending_max_amount"
                  type="number"
                  label="Sending Max Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="receiving_min_amount"
                  type="number"
                  label="Receiving Min Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="receiving_max_amount"
                  type="number"
                  label="Receiving Max Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="is_sending_country"
                  :items="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  label="Is Sending Country"
                />
              </v-col> -->
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    country: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    url() {
      if (this.country && this.country.id) {
        return `api/v1/transactions/cryptoCountries/${this.country.id}`;
      }
      return "api/v1/transactions/cryptoCountries";
    },
  },
};
</script>
